import axios from 'axios';
import { LINK_TREE_ENDPOINT } from '@dynameat/constants';

export const linkTreeListRequest = (point_of_sale__guid) => axios.get(
  LINK_TREE_ENDPOINT(), { params: { point_of_sale__guid, page_size: 0 } }
);

export const createLinkTreeRequest = (linkTree) => axios.post(LINK_TREE_ENDPOINT(), linkTree, { headers: { 'content-type': 'application/json' } });

export const editLinkTreeRequest = (linkTreeGuid, data) => axios.patch(LINK_TREE_ENDPOINT(linkTreeGuid), data, { headers: { 'content-type': 'application/json' } });

export const deleteLinkTreeRequest = (linkTreeGuid) => axios.delete(LINK_TREE_ENDPOINT(linkTreeGuid));
